import styled from 'styled-components';

const QuestionText = styled.h3`
  font-size: 18px;
  color: ${({ color }) => color};
  font-family: ${({ fontFamily }) => fontFamily};
  font: ${({ font }) => font};
`;

const QuestionDescription = styled.h4`
  color: ${({ color }) => color};
  font-size: 16px;
  font-family: ${({ fontFamily }) => fontFamily};
  font: ${({ font }) => font};
`;

const InputWrapper = styled.div`
  span[data-testid='pre-text'] {
    color: #262d3f;
  }
  display: ${({ inputType }) => (inputType === 'dateInput' ? 'block' : 'flex')};
  ${({ styles }) => styles};
  @media (min-width: 360px) {
    margin-right: 0px;
  }
  @media (min-width: 768px) {
    margin-right: 15px;
  }
  @media (max-width: 767px) {
    ${({ questionId }) => questionId === 'QR_EmailAddress' && 'flex-direction: column;'};
  }
  & > input:-moz-placeholder,
  input::-moz-placeholder {
    opacity: 1;
  }
  // Datepicker color contrast configurations
  [class*='app--datepicker--day'],
  [class*='app--datepicker--month'] {
    color: #000000;
    &[aria-disabled='true'] {
      color: #585858;
    }
    &[data-selected='true'],
    &[data-keyboard-selected='true'] {
      color: #ffffff;
      &:hover {
        color: #000000;
      }
    }
    &:active {
      background: #f0f0f0;
      color: #000000;
    }
    &[aria-disabled='true'][data-selected='true'] {
      background: #2965cc;
      &:active {
        background: #2965cc;
        color: #ffffff;
      }
    }
  }
  [class*='app--datepicker--month'] {
    &:focus {
      color: #ffffff;
      &:hover {
        color: #000000;
      }
    }
  }
  @media (forced-colors: active) {
    div[class*='app--datepicker--year'],
    div[class*='app--datepicker--month'],
    div[class*='app--datepicker--day'] {
      border: none;
      &:focus {
        outline: 1px solid ButtonText;
      }
      &[data-selected='true'] {
        color: ButtonText;
        background: Highlight;
        forced-color-adjust: none;
      }
    }
  }
`;

const SelectWrapper = styled.div`
  ${(props) => (props.floatingLabel ? '' : 'margin-top: 11px;')}
  div[name=select-wrapper] > div > div > div > div + div > div > input {
    opacity: 0 !important;
  }
  div[name='select-wrapper'] > div > div > div > div + div > div > input::placeholder {
    color: #262d3f;
  }
  div[name='select-wrapper'] > div > div > div > div {
    color: #262d3f;
  }
  div[name='select-wrapper']:focus-within > div > div > div > div + div > div > input {
    opacity: 1 !important;
  }
  @media (min-width: 768px) {
    margin: 0px 15px 4px 0px;
  }
  @media (forced-colors: active) {
    ${({ disabled }) =>
      disabled &&
      `
      & [class$="-control"] {
        border: 1px solid Highlight !important;
      }
    `}
  }
`;

const Wrapper = styled.div`
  margin: ${({ customWrapperMargin }) => customWrapperMargin || '0 0 12% 0'};
  .rangeslider {
    margin: ${(props) => (props.margin ? props.margin : '100px 0')};
  }

  .rangeslider__handle {
    background: ${(props) =>
      props.background ? `${props.background}!important` : 'rgba(226, 226, 226, 1)'};
  }

  .rangeslider__handle-tooltip {
    color: ${(props) =>
      props.background ? `${props.background}!important` : 'rgba(41, 101, 204, 1);'};
    text-align: center;
    font-size: 30px;
  }
`;

export { QuestionDescription, QuestionText, InputWrapper, SelectWrapper, Wrapper };
